import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageService, ConfirmationService } from 'primeng/api';
import { CategoryService } from '../../../services/categories.service';
import { Category } from '../../../models/category';
import { Observable, of } from 'rxjs';
import { AbstractFormComponent } from 'src/app/common/abstract-edit.component';
import { PARAM_CATEGORIES_PATH } from 'src/app/constants/constants';
import { Bind } from 'primeng/bind';
import { Card } from 'primeng/card';
import { ButtonDirective } from 'primeng/button';
import { InputText } from 'primeng/inputtext';

import { SelectButton } from 'primeng/selectbutton';
import { Toast } from 'primeng/toast';
import { TranslatePipe } from '@ngx-translate/core';

import { TPipe } from "../../../i18n/t.pipe";
@Component({
    standalone: true,
    selector: 'app-category-form',
    templateUrl: './category-form.component.html',
    imports: [TPipe, FormsModule, ReactiveFormsModule, Bind, Card, ButtonDirective, InputText, SelectButton, Toast, TranslatePipe]
})
export class CategoryFormComponent extends AbstractFormComponent<Category> implements OnInit {
  protected fb: FormBuilder;
  private categoryService = inject(CategoryService);

  pageTitle: string;
  form: FormGroup;
  idField = 'id';
  formFields = ['id', 'name', 'description', 'seo_url', 'is_active'];
  item$: Observable<Category> = of();

  service = this.categoryService;

  constructor() {
    const fb = inject(FormBuilder);
    const messageService = inject(MessageService);
    const confirmationService = inject(ConfirmationService);
    const router = inject(Router);
    const route = inject(ActivatedRoute);

    super(fb, messageService, confirmationService, router, route, PARAM_CATEGORIES_PATH);

    this.fb = fb;
  }

  ngOnInit() {
    this.initializeForm();
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.pageTitle = 'Modifica Categoria';
      this.loadItem(id);
    } else {
      this.pageTitle = 'Aggiungi Categoria';
    }
  }

  initializeForm() {
    this.form = this.fb.group({
      id: [''],
      name: ['', Validators.required],
      description: [''],
      seo_url: [''],
      is_active: ["0"]
    });
  }

  loadItem(id: string) {
    this.service.getId(id).subscribe(
      res => {
        this.form.patchValue({
          name: res.name,
          description: res.description,
          seo_url: res.seo_url,
          is_active: res.is_active,
          id: res.id
        });
      },
      error => this.error = error
    );
  }
}
